import { deleteSegmentGroupSuccess, toggleDeleteSegmentGroupModal } from "app/actions/segmentsModuleActions";
import type { IDeleteGroupConfirmationModalProps } from "pro-features/components/Modals/src/DeleteGroupConfirmationModal";
import { DeleteGroupConfirmationModal } from "pro-features/components/Modals/src/DeleteGroupConfirmationModal";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import type { ICustomSegmentsGroup } from "app/services/segments/segmentsApiService";
import SegmentsApiService from "app/services/segments/segmentsApiService";
import { SegmentsUtils } from "app/services/segments/SegmentsUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

interface ISegmentsDeleteGroupConformationModalProps {
    isOpen: boolean;
    group?: ICustomSegmentsGroup;
    toggleDeleteSegmentGroupModal: (isOpen, group) => void;
    deleteSegmentGroupSuccess: (group) => void;
    params: any;
    currentPage: string;
}

const DeleteSegmentsGroupConfirmationModal: FC<ISegmentsDeleteGroupConformationModalProps> = ({
    isOpen,
    group,
    toggleDeleteSegmentGroupModal,
    deleteSegmentGroupSuccess,
    params,
    currentPage,
}) => {
    const [isModalOpen, setModalIsOpen] = useState(isOpen);
    useEffect(() => {
        setModalIsOpen(isOpen);
    }, [isOpen]);
    const segmentsApiService = new SegmentsApiService();
    const onCancelClick = () => {
        allTrackers.dispatchTrackEvent("Button", "click", `Delete confirmation/Cancel/${group.name || ""}`);
        toggleDeleteSegmentGroupModal(false, undefined);
    };

    const onApproveClick = async () => {
        allTrackers.dispatchTrackEvent("Button", "click", "Delete confirmation/OnApprove/${group.name}");
        await segmentsApiService.deleteCustomSegmentsGroup({ id: group.id });
        toggleDeleteSegmentGroupModal(false, undefined);
        setModalIsOpen(false);
        if (params.id === group.id) {
            const currentModule = proNavigator.getCurrentModule();
            const targetStateName = `${currentModule}-homepage`;
            await proNavigator.go(targetStateName, { ...SegmentsUtils.getPageFilterParams() }, { reload: true });
        }
        deleteSegmentGroupSuccess(group);
    };

    const onCloseClick = () => {
        allTrackers.dispatchTrackEvent("Button", "click", "Button");
        toggleDeleteSegmentGroupModal(false, undefined);
        setModalIsOpen(false);
    };

    const confirmationModal: IDeleteGroupConfirmationModalProps = {
        onCancelClick,
        onApproveClick,
        onCloseClick,
        isOpen: isModalOpen,
        confirmationTitle: "conversion.delete.segment.group.title",
        confirmationSubtitle: "conversion.delete.segment.group.subtitle",
        groupname: group?.name,
    };
    return <DeleteGroupConfirmationModal {...confirmationModal} />;
};

function mapStateToProps(store) {
    const {
        routing: { params, currentPage },
        segmentsModule: { deleteSegmentGroupIsOpen, segmentGroup },
    } = store;
    return {
        params,
        currentPage,
        isOpen: deleteSegmentGroupIsOpen,
        group: segmentGroup,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        toggleDeleteSegmentGroupModal: (isOpen, segmentGroup) => {
            dispatch(toggleDeleteSegmentGroupModal(isOpen, segmentGroup));
        },
        deleteSegmentGroupSuccess: (segmentGroup) => {
            dispatch(deleteSegmentGroupSuccess(segmentGroup));
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSegmentsGroupConfirmationModal);
